import { render, staticRenderFns } from "./yclfx.vue?vue&type=template&id=62b856dd&scoped=true&"
import script from "./yclfx.vue?vue&type=script&lang=js&"
export * from "./yclfx.vue?vue&type=script&lang=js&"
import style0 from "./yclfx.vue?vue&type=style&index=0&id=62b856dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b856dd",
  null
  
)

export default component.exports